import { render } from "./Main.vue?vue&type=template&id=7af68e72"
const script = {}
script.render = render

export default script